module.exports = __webpack_public_path__ + "assets/img/bg-decarate-94b48bf7.png";